import templateAdmin from '../../../../Template/config/components/adminView'
import adminConfigManager from './adminConfigManager'

export default {
    ...templateAdmin,
    adminConfigManager
}
